export const text = {
  NAME: 'Name:',
  MRN: 'MRN:',
  EMAIL: 'Email:',
}
